import { render, staticRenderFns } from "./ChatPromptAdmin.vue?vue&type=template&id=0a8393c9&"
import script from "./ChatPromptAdmin.vue?vue&type=script&lang=js&"
export * from "./ChatPromptAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports